import React from 'react'

// const debug = "FieldProto_PickerValueNotEmpty"
const debug = false

export default function FieldProto_PickerValueNotEmpty(props: any) {

    // search for '_PickerValueNotEmpty' for examples...

    debug && console.log(debug, 'render', props)

    const classes       = Classes("ui5-field-picker", props.className)
    const iconClasses   = Classes("icon", props.field.icon, props.configOptions?.iconClass || props.options?.iconClass)

    return (
        <div className  = {classes}
             onClick    = {props.onClick}
        >
            <div className={iconClasses}/>
            {props.children}
        </div>
    )

}
